module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item 
    ; __append("\n")
    ;  var access = item.access 
    ; __append("\n<div class=\"padding__medium absolute ltrb-0\" style=\"overflow-y: auto\">\n	<div class=\"table wh100\">\n		<div>\n			<div>\n				<div class=\"table w100 form__edit-form table-stripped\">\n					")
    ;  Util.each(access, function (key, index) { 
    ; __append("\n					<div>\n						<div>\n							")
    ; __append(escapeFn( key.name ))
    ; __append("\n						</div>\n						<div>\n							")
    ; __append(escapeFn( key.description ))
    ; __append("\n						</div>\n						<div style=\"width: 450px\">\n							")
    ; __append( UI.Template.render("Html/CheckboxGroup", { type: "enum", collection: Security.AccessMode, options: { checked: pgIntArrayDecode(key.mode), "on-click": "onModeClick", column: index } }) )
    ; __append("\n						</div>\n					</div>\n					")
    ;  }) 
    ; __append("\n				</div>\n			</div>\n			<div class=\"form__edit-form_buttons cell__right w0\">\n				<!--<div>-->\n					<!--<button class=\"button__save w100\" on-click=\"onSaveClick\">Сохранить</button>-->\n				<!--</div>-->\n				<div>\n					<button class=\"button__save w100\" on-click=\"onSaveCloseClick\">Сохранить и закрыть</button>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>\n")
  }
  return __output.join("");

}